import { render, staticRenderFns } from "./AddNewTestimonialModal.vue?vue&type=template&id=b1b1ccf0&"
import script from "./AddNewTestimonialModal.vue?vue&type=script&lang=js&"
export * from "./AddNewTestimonialModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewTestimonialModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports